import { types, actions } from './requests'
export const GETSESSIONDATA_TYPES = {
    ...types('GETSESSIONDATA'),
}
export const GETSESSIONDATA_ACTIONS = {
    ...actions('GETSESSIONDATA'),
}